export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/pdfExport.worker.b03230cd.worker.js");
}
